import React from "react";
import { ReactComponent as LoginIcon } from "@/assets/sidebar/login.svg?react";
import { SideBarButton } from "./styles";

interface LogoutButtonProps {
  isCollapsed: boolean;
  accessToken: string | null;
  username?: string;
  onLogoutClick: () => void;
}

export const LogoutButton: React.FC<LogoutButtonProps> = ({
  isCollapsed,
  accessToken,
  username,
  onLogoutClick,
}) => {
  const isLoggedIn = !!accessToken;

  const buttonStyle: React.CSSProperties = {
    padding: "0px",
    cursor: "default",
    justifyContent: isLoggedIn && !isCollapsed ? "space-between" : "flex-start",
  };

  const handleLogoutIconClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onLogoutClick();
  };

  const logoutIconWrapperStyle: React.CSSProperties = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  const logoutIconStyle: React.CSSProperties = {
    width: "24px",
    height: "24px",
    transform: "rotate(180deg)",
    cursor: "pointer",
  };

  return (
    <SideBarButton
      style={buttonStyle}
      $isCollapsed={isCollapsed}
    >
      <>
        <span>{username}</span>
        <div
          style={logoutIconWrapperStyle}
          onClick={handleLogoutIconClick}
          title="로그아웃"
        >
          <LoginIcon style={logoutIconStyle} title="로그아웃" />
        </div>
      </>
    </SideBarButton>
  );
};
